import React from 'react';

import useAppNavigation from '~/hooks/useAppNavigation';

import ChainSearchResults from './ChainsSearchResults';

const ChainSearchResultsContainer = (props) => {
  const { push } = useAppNavigation();

  return (
    <ChainSearchResults
      onRowClick={(row) => {
        if (props.tableType === 'id') {
          push('/vendors/chain/' + row.sfid);
        } else {
          push('/vendors/chain/' + row.parentid);
        }
      }}
      {...props}
    />
  );
};

export default ChainSearchResultsContainer;
